module.exports = __webpack_public_path__ + "static/media/5.f4d31a71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Managing/5.jpg
// module id = 1641
// module chunks = 0